import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DetailLayoutComponent, EmptyStateComponent, IBackEvent } from '@tecalisdev/infinity';
import { DetailResourceErrorKind } from '../../../core/utils/http-resource-error.utils';

@Component({
	selector: 'app-detail-resource-error',
	imports: [DetailLayoutComponent, EmptyStateComponent, TranslatePipe],
	templateUrl: './detail-resource-error.component.html',
})
export class DetailResourceErrorComponent {
	public readonly kind = input.required<DetailResourceErrorKind>();
	public readonly titleKey = input.required<string>();
	public readonly descriptionKey = input.required<string>();
	public readonly showRetry = input(false);
	public readonly retryLabelKey = input('BUTTON.RETRY');

	public readonly backEvent = output<IBackEvent>();
	public readonly retryEvent = output<void>();

	public onBack(event: IBackEvent): void {
		this.backEvent.emit(event);
	}

	public onRetry(): void {
		this.retryEvent.emit();
	}
}
